import {
  HUMAN_PROJECT_DETAILS_BY_ID_LOADING,
  HUMAN_PROJECT_DETAILS_BY_ID_SUCCESS,
  HUMAN_PROJECT_DETAILS_BY_ID_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { humanitarainCasesUrl } from "api/apiUrls";

export const humanProjectDetailsByIdActions =
  (id: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: HUMAN_PROJECT_DETAILS_BY_ID_LOADING, payload: true });
      const response = await listSingleItemService(
        `${humanitarainCasesUrl}`,
        `?id=${id}`
      );

      dispatch({
        type: HUMAN_PROJECT_DETAILS_BY_ID_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({ type: HUMAN_PROJECT_DETAILS_BY_ID_FAILURE, payload: err });
    } finally {
      dispatch({ type: HUMAN_PROJECT_DETAILS_BY_ID_LOADING, payload: false });
    }
  };
